import React from 'react';
import { TitleSemicircle } from '../FinderDetailPage/ExploreNames/styled';
import {
  UniqueTitle,
  UniqueTitleSpan,
} from '../FinderDetailPage/UniqueBabyNames/styled';
import MostPopuparNameEach from './MostPopuparNameEach';
import { ReligiousSection, ReligiousWiseName } from './styled';

export default function MostPopularName({ detailPage }) {
  const typeOfReligion = [
    'Hindu',
    'Muslim',
    'Christianity',
    'Sikh',
    'Buddhism',
    'Jainism',
    'Judaism',
  ];
  return (
    <ReligiousSection>
      <UniqueTitle>
        <TitleSemicircle unique></TitleSemicircle>{' '}
        <UniqueTitleSpan>BABY NAMES BY RELIGION</UniqueTitleSpan>
      </UniqueTitle>
      <ReligiousWiseName>
        {typeOfReligion?.map((data, index) => {
          return (
            <MostPopuparNameEach
              data={data}
              index={index}
              key={`${data}-${index}`}
              detailPage={detailPage}
            />
          );
        })}
      </ReligiousWiseName>
    </ReligiousSection>
  );
}
